import { useMutation } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";

type CreateCompany = {
    company: CompanyWrite;
    companyId?: number;
};
export const useCreateOrganization = () => {
    const query = useMutation({
        mutationFn: async (options: CreateCompany) => {
            const { company, companyId } = options;

            const params = companyId !== undefined ? { organization_id: companyId } : undefined;

            const response =
                company.id === undefined ?
                    await loggedInApiCall.post("/api/organizations", company, { params })
                :   await loggedInApiCall.put("/api/organizations/" + company.id, company, { params });

            return response;
        },
    });

    return query;
};

export type CompanyType = "provider"; // Only for suppliers now
export type OrganizationType = string;

export type CompanyWrite = {
    // id decides whether it's POST or PUT.
    id?: number;

    name: string | null;
    clientId?: string | null | undefined;
    registrationNumber?: string | null | undefined;
    externalId?: string | null | undefined;
    users?: IRI[];

    isProvider?: boolean; // Boolean to indicate if it's a supplier
    organizationType?: IRI | null; // For organizational structure

    address1?: string;
    address2?: string;
    zipcode?: string;
    city?: string;
    state?: string;
    country?: string;
    phone?: string;
    email?: string;
    organizationSector?: IRI | null;
    parents?: IRI[];
    tags?: Record<string, string[]>;
    jsonAttributes?: Record<string, any>;
};
